// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCaretDownOutlinedSvg from "@fishx/icons-svg/es/asn/PCaretDownOutlined";
import FishxIcon from '../components/FishxIcon';

var PCaretDownOutlined = function PCaretDownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCaretDownOutlinedSvg
  }));
};

PCaretDownOutlined.displayName = 'PCaretDownOutlined';
export default React.forwardRef(PCaretDownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCaretDownOutlined.js
// module id = 3263
// module chunks = 0